.link {
  display: inline-flex;
  align-items: center;
  gap: var(--s-3);
  max-width: 100%;
  min-height: var(--h-control-sm);
  padding: 0 var(--s-4);
  margin: 0 calc(-1 * var(--s-4));
  border: 0;
  border-radius: var(--r-sm);
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--text-link);
  transition:
    background var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard);
}
.link:hover {
  color: var(--text-link-hover);
  background: var(--action-quiet-hover);
  border: 0;
}
.link:active {
  background: var(--action-quiet-active);
}
.texto {
  min-width: 0;
  overflow-wrap: anywhere;
}
@media (prefers-reduced-motion: reduce) {
  .link {
    transition: none;
  }
}
